module.exports = __webpack_public_path__ + "img/smart-a-1.dbfe5ddb.png";